import axios from "axios";
import { LoginCredentials, LoginResponse } from "../types/auth";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

export const login = (
  credentials: LoginCredentials,
): Promise<{ data: LoginResponse }> => API.post("/auth/login", credentials);

// export const loginSSO = (): Promise<{ data: LoginResponse }> =>
//   API.post("/auth/azure/login");

/* export const impersonate = (
  userObj : { userID: number | null }
): Promise<{data: LoginResponse }> => API.post("/auth/impersonate", userObj) */
